import type {ReactAction} from '@netx/core/bootstrap';
import {faCopy} from '@fortawesome/pro-solid-svg-icons';
import {canManageUploadAssetRequests} from '../enablers';
import {UploadAssetRequestsManageLabel} from '../locales';
import type {IUploadAssetRequest} from '../types';

export const uploadAssetRequestActionDuplicateIcon = faCopy;

export type UploadAssetRequestActionDuplicateParams = Partial<
	Omit<ReactAction, 'cb'>
> & {
	cb: (uploadAssetRequest: IUploadAssetRequest) => void;
};

/**
 *
 * @param params
 * @returns Action
 */
export const uploadAssetRequestActionDuplicate = (
	uploadAssetRequest: IUploadAssetRequest,
	{cb, ...params}: UploadAssetRequestActionDuplicateParams,
): ReactAction => ({
	name: 'upload-asset-requests-duplicate',
	cb: () => cb(uploadAssetRequest),
	enableTest: () => canManageUploadAssetRequests(),
	icon: uploadAssetRequestActionDuplicateIcon,
	label: UploadAssetRequestsManageLabel.DUPLICATE,
	...params,
});
